import {
  IExternalLogger,
  LogLevel
} from '@kameleoon/javascript-sdk-core/browser';

/**
 * A simple implementation of a logger for js clients that prints log messages to the console with timestamp.
 * This logger implements the {@code IExternalLogger} interface.
 */
export class DefaultLogger implements IExternalLogger {
  public log(level: LogLevel, message: string): void {
    const date = new Date();
    const formattedDate = date.toLocaleString('en-US', { timeZoneName: 'short' });
    message = `${formattedDate} ${message}`;
    switch (level) {
      case LogLevel.DEBUG:
        console.debug(message);
        break;
      case LogLevel.INFO:
        console.info(message);
        break;
      case LogLevel.WARNING:
        console.warn(message);
        break;
      case LogLevel.ERROR:
        console.error(message);
        break;
    }
  }
}
